/**
 * Created by slava on 23/11/17
 */

MiniGameWindow = CleverappsWindow.extend({
    onWindowLoaded: function (reward) {
        this._super({
            name: "MiniGameWindow",
            content: this.getContent(),
            closeButton: false,
            noBackground: true
        });

        this.reward = reward;
    },

    getContent: function () {
        this.bg = new cleverapps.Spine(bundles.minigame.jsons.minigame_bg_json);

        this.createBalloons();
        this.createFooter();
        this.createTitle();

        this.bg.setAnimation(0, "animation", false);

        return this.bg;
    },

    createTitle: function () {
        const slot = this.bg.getSlot("slot_title");

        const text = cleverapps.UI.generateOnlyText(
            Messages.get("MiniGameWindow.Title"),
            cleverapps.styles.FONTS.MINI_GAME_BALLOONS_WINDOW_TITLE_TEXT
        );
        text.fitTo(slot.width);
        text.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        slot.addChild(text);
    },

    createFooter: function () {
        const slot = this.bg.getSlot("slot_footer");

        const text = cleverapps.UI.generateOnlyText(
            Messages.get("MiniGameWindow.Footer"),
            cleverapps.styles.FONTS.MINI_GAME_BALLOONS_WINDOW_FOOTER_TEXT
        );
        text.fitTo(slot.width);
        text.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        slot.addChild(text);
    },

    createBalloons: function () {
        const balloonSkins = new cleverapps.Spine(bundles.minigame.jsons.minigame_balloon_json).listSkins();
        PseudoRandom.GET().shuffle(balloonSkins);

        const actions = [];

        for (const slotName in this.bg.slots) {
            if (!slotName.startsWith("slot_balloon")) {
                continue;
            }

            const slot = this.bg.getSlot(slotName);

            const balloon = new cleverapps.Spine(bundles.minigame.jsons.minigame_balloon_json);
            balloon.setSkin(balloonSkins.pop());

            balloon.setAlignment({
                x: { align: "center" },
                y: { align: "center" }
            });
            balloon.setAnimation(0, "idle", true);
            balloon.setTimeScale(Math.random() + 0.5);

            cleverapps.UI.onClick(balloon, () => {
                if (!cleverapps.miniGame.locked) {
                    cleverapps.miniGame.open();
                    cleverapps.metrics.logEvent(cleverapps.EVENTS.DAILY_BONUS);
                    balloon.setCompleteListener(() => {
                        this.close();

                        cleverapps.focusManager.display({
                            focus: "MiniGameRewardWindow",
                            stack: true,
                            action: (f) => {
                                RewardWindow.createMiniGameWindow(this.reward);
                                cleverapps.focusManager.onceNoWindowsListener = f;
                            }
                        });
                    });
                    balloon.setAnimation(0, "pop", false);
                    cleverapps.effects.fire("minigame.balloon.pop");
                }
            });

            balloon.setVisible(false);
            slot.addChild(balloon);

            actions.push(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.CallFunc(() => balloon.runAction(StandartAnimations.showUp(balloon, {
                    flash: true
                })))
            ));
        }

        PseudoRandom.GET().shuffle(actions);
        this.runAction(new cc.Sequence(actions));
    },

    onShow: function () {
        this._super();
        cleverapps.effects.fire("minigame.balloons.appear");
    },

    listBundles: function () {
        return ["minigame"];
    }
});

RewardWindow.createMiniGameWindow = function (reward) {
    return new RewardWindow(reward, {
        title: Messages.get("MiniGameRewardWindow.title"),
        name: "minigamerewardwindow",
        text: Messages.get("MiniGameRewardWindow.text"),
        event: cleverapps.EVENTS.EARN.DAILY_MINIGAME_BALLOONS
    });
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MINI_GAME_BALLOONS_WINDOW_FOOTER_TEXT: {
        size: 45,
        color: new cc.Color(96, 29, 12, 255)
    },
    MINI_GAME_BALLOONS_WINDOW_TITLE_TEXT: {
        size: 75,
        color: new cc.Color(171, 97, 50, 255)
    }
});